import { GameVars } from "../../../GameVars";

export class CoinsEnemy extends Phaser.GameObjects.Container {
 
    constructor(scene: Phaser.Scene, x: number, y: number, coins: number) {

        super(scene);

        this.x = x;
        this.y = y;

        let text = new Phaser.GameObjects.Text(this.scene, 0, 0, " + " + coins + " ", {fontFamily: "Lithos", fontSize: "14px", color: "#ffffff"});
        text.setStroke("#101e2f", 4);
        text.setShadow(2, 1, "#101e2f", 1, true, false); 
        text.setOrigin(1, .5);
        this.add(text);  

        let img = new Phaser.GameObjects.Image(this.scene, 2, 0, "texture_atlas_1", "rock_gains");
        img.setOrigin(0, .5);
        img.setScale(.75);
        this.add(img);
        
        this.scene.tweens.add({
            targets: this,
            y: this.y - 20,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: GameVars.timeStepFactor === 1 ? 500 : 250,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this,
                    alpha: 0,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: GameVars.timeStepFactor === 1 ? 1500 : 500,
                    onComplete: () => {
                        this.destroy();
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });
    }
}
